import { CKRadio } from '@clearkit/react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { RadioGroup } from 'reakit/Radio';

import { hasError } from '~/lib/graphql';

import styles from './styles';

const TriggerType = ({
  classes,
  errors,
  handleChange,
  triggerType,
  triggerTypes,
}) => (
  <div className={classes.contentBox}>
    <FormControl
      className={classes.formControl}
      error={hasError(errors, 'triggerType')}
      required>
      {hasError(errors, 'triggerType') && (
        <FormHelperText className={classes.errorText}>
          You must choose a trigger type
        </FormHelperText>
      )}

      <RadioGroup
        value={triggerType}
        onChange={(event) => {
          handleChange('triggerType', event.target.value);
        }}>
        <div className="flex flex-col space-y-2">
          {triggerTypes.map(({ value, label }) => (
            <CKRadio
              key={value}
              id={value}
              value={value}
              label={label}
              checked={triggerType === value}
              classes={{ root: classes.radioRoot }}
            />
          ))}
        </div>
      </RadioGroup>
    </FormControl>
  </div>
);

TriggerType.propTypes = {
  classes: PropTypes.object,
  errors: PropTypes.array,
  handleChange: PropTypes.func,
  triggerType: PropTypes.string,
  triggerTypes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.node,
    }),
  ),
};

export default withStyles(styles)(TriggerType);
